import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

// Cart utilities (localStorage)
export const cartUtils = {
  get() {
    try { return JSON.parse(localStorage.getItem("vf_cart") || "[]"); } catch { return []; }
  },
  set(items) { localStorage.setItem("vf_cart", JSON.stringify(items)); window.dispatchEvent(new Event("cart-updated")); },
  add(product, qty = 1) {
    const items = cartUtils.get();
    const idx = items.findIndex((i) => i.product_id === product.id);
    if (idx >= 0) items[idx].quantity += qty;
    else items.push({ product_id: product.id, name: product.name, price: product.price, image: product.images?.[0], quantity: qty });
    cartUtils.set(items);
  },
  updateQty(product_id, quantity) {
    const items = cartUtils.get().map((i) => i.product_id === product_id ? { ...i, quantity } : i).filter((i) => i.quantity > 0);
    cartUtils.set(items);
  },
  remove(product_id) { cartUtils.set(cartUtils.get().filter((i) => i.product_id !== product_id)); },
  clear() { cartUtils.set([]); },
  count() { return cartUtils.get().reduce((s, i) => s + i.quantity, 0); },
  total() { return cartUtils.get().reduce((s, i) => s + i.price * i.quantity, 0); },
};

export const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

// ---------- Wishlist utilities (server-backed, requires login) ----------
// Keep a light localStorage cache of wishlisted product IDs so the heart icon
// on product cards can render instantly without waiting on the API.
const WL_KEY = "vf_wishlist_ids";

export const wishlistUtils = {
  ids() {
    try { return new Set(JSON.parse(localStorage.getItem(WL_KEY) || "[]")); } catch { return new Set(); }
  },
  _setIds(set) {
    localStorage.setItem(WL_KEY, JSON.stringify([...set]));
    window.dispatchEvent(new Event("wishlist-updated"));
  },
  has(productId) { return wishlistUtils.ids().has(productId); },
  count() { return wishlistUtils.ids().size; },
  async refresh() {
    try {
      const r = await api.get("/wishlist/ids");
      const set = new Set(r.data.ids || []);
      wishlistUtils._setIds(set);
      return set;
    } catch { return wishlistUtils.ids(); }
  },
  async add(productId) {
    await api.post(`/wishlist/${productId}`);
    const set = wishlistUtils.ids();
    set.add(productId);
    wishlistUtils._setIds(set);
  },
  async remove(productId) {
    await api.delete(`/wishlist/${productId}`);
    const set = wishlistUtils.ids();
    set.delete(productId);
    wishlistUtils._setIds(set);
  },
  clear() { wishlistUtils._setIds(new Set()); },
};
